

import React, { useState,useEffect } from "react";
import axios from "axios";

import Layout from "../components/Layout";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";

import { TrafficDataApi } from "../Data/api";

const TrafficData = () => {
  

  // const today = new Date();

  // const [startDate, setStartDate] = useState(today);
  // const [endDate, setEndDate] = useState(today);

  const today = new Date();

// First day of the current month
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

const [startDate, setStartDate] = useState(firstDayOfMonth);
const [endDate, setEndDate] = useState(today);


  const [service, setService] = useState("kiddocraze");

  const [trafficData, setTrafficData] = useState([]);
  const [loading, setLoading] = useState(false);

  // common responsive styles

  const inputStyle = {
    width: "100%",
  };

  const filterItemStyle = {
    display: "flex",

    flexDirection: "column",

    gap: "8px",

    flex: "1 1 230px",
  };

  const labelStyle = {
    fontWeight: "600",

    color: "#475569",
  };

  const services = [
    {
      label: "KiddoCraze",
      value: "kiddocraze",
    },

    {
      label: "Vision Game",
      value: "visiongame",
    },

    {
      label: "Digitize AI",
      value: "digitizeAi",
    },

    {
      label: "Wonder Mind",
      value: "wondermind",
    },

    {
      label: "Kickwinn",
      value: "kickwinn",
    },
  ];

  const formatDate = (date) => {
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const fetchTrafficData = async () => {
    try {
      if (!startDate || !endDate || !service) {
        alert("Please select service and date range");

        return;
      }

      setLoading(true);

      const response = await axios.get(
        TrafficDataApi,

        {
          params: {
            service,

            startDate: formatDate(startDate),

            endDate: formatDate(endDate),
          },
        },
      );

      if (response.data.success) {
        setTrafficData(response.data.data);
      }
    } catch (error) {
      console.log("Traffic Error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  fetchTrafficData();
}, []);

  const dateTemplate = (row) => {
    const date = new Date(row.activation_date);

    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const percentageTemplate = (row, field) => {
    return `${row[field]} %`;
  };

  return (
    <Layout>
      <div
        style={{
          padding: "clamp(12px,3vw,25px)",
        }}
      >
        {/* FILTER CARD */}

        <div
          className="card"
          style={{
            background: "#fff",
            borderRadius: "18px",
            padding: "clamp(18px,3vw,28px)",
            marginBottom: "25px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
            border: "1px solid #e5e7eb",
          }}
        >
          <h2
            style={{
              marginBottom: "30px",
              fontSize: "24px",
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Traffic Data Report
          </h2>

          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-end",
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            {/* START DATE */}

            <div style={filterItemStyle}>
              <label style={labelStyle}>Start Date</label>

              <Calendar
                value={startDate}
                onChange={(e) => setStartDate(e.value)}
                showIcon
                dateFormat="yy-mm-dd"
                placeholder="Select Start Date"
                style={inputStyle}
              />
            </div>

            {/* END DATE */}

            <div style={filterItemStyle}>
              <label style={labelStyle}>End Date</label>

              <Calendar
                value={endDate}
                onChange={(e) => setEndDate(e.value)}
                showIcon
                dateFormat="yy-mm-dd"
                placeholder="Select End Date"
                style={inputStyle}
              />
            </div>

            {/* SERVICE */}

            <div style={filterItemStyle}>
              <label style={labelStyle}>Service</label>

              <Dropdown
                value={service}
                options={services}
                onChange={(e) => setService(e.value)}
                placeholder="Select Service"
                style={inputStyle}
              />
            </div>

            {/* BUTTON */}

            <Button
              label="Fetch Report"
              icon="pi pi-search"
              onClick={fetchTrafficData}
              style={{
                height: "46px",

                padding: "0 32px",

                borderRadius: "14px",

                fontWeight: "700",

                fontSize: "15px",

                background: "linear-gradient(135deg,#4f46e5,#2563eb)",

                color: "#ffffff",

                border: "none",

                boxShadow: "0 8px 20px rgba(37,99,235,0.35)",

                flex: "1 1 180px",
              }}
            />
          </div>
        </div>

        {/* TABLE CARD */}

        <div
          className="card"
          style={{
            background: "#fff",

            borderRadius: "18px",

            padding: "clamp(15px,3vw,25px)",

            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",

            border: "1px solid #e5e7eb",

            overflowX: "auto",
          }}
        >
          {loading ? (
            <div
              style={{
                textAlign: "center",

                padding: "50px",
              }}
            >
              <ProgressSpinner />
            </div>
          ) : (
            <DataTable
              value={trafficData}
              paginator
              rows={10}
              stripedRows
              showGridlines
              responsiveLayout="scroll"
              scrollable
              emptyMessage="No Traffic Data Found"
              tableStyle={{
                minWidth: "850px",
              }}
            >
              <Column
                header="Sr No."
                body={(row, options) => options.rowIndex + 1}
              />

              <Column
                field="activation_date"
                header="Activation Date"
                body={dateTemplate}
              />

              <Column field="total_activations" header="Total Activations" />

              <Column field="first_successful_charges" header="First Charges" />

              <Column
                header="First Charge %"
                body={(row) => percentageTemplate(row, "first_charge_rate_pct")}
              />

              <Column field="total_renewals" header="Renewals" />

              <Column
                header="Renewal %"
                body={(row) => percentageTemplate(row, "renewal_rate_pct")}
              />
            </DataTable>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default TrafficData;
